import { render, staticRenderFns } from "./AnimatedDecimalNumber.vue?vue&type=template&id=636b77c5&scoped=true&"
import script from "./AnimatedDecimalNumber.vue?vue&type=script&lang=js&"
export * from "./AnimatedDecimalNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b77c5",
  null
  
)

export default component.exports